import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import StopList from "./views/StopList";
import BSDList from "./views/BSDList";
import BSDLoglist from "./views/deviceLog/BSDLoglist";
import StopLoglist from "./views/deviceLog/StopLoglist";
import BSDImport from "./views/importFile/BSDImport";
import RouteWrapper from "../../../routing/RouterWrapper";// adjust path as needed

const BSDWrapper = () => {
  return (
    <Routes>
      <Route path="/" element={<OutletWrapper />}>
        <Route path="detail" element={<RouteWrapper component={BSDList} />} />
        <Route path="stop" element={<RouteWrapper component={StopList} />} />
        <Route path=":deviceId" element={<RouteWrapper component={BSDLoglist} />} />
        <Route path="stops/:stopId" element={<RouteWrapper component={StopLoglist} />} />
        <Route path="file/Import" element={<RouteWrapper component={BSDImport} />} />
      </Route>
    </Routes>
  );
};

const OutletWrapper = () => <Outlet />;

export default BSDWrapper;
